import * as api from '../resources/user.api';
import actionTypes from './trusted-devices.action-types';

export const fetchTrustedDevicesRequest = () => ({
  type: actionTypes.FETCH_TRUSTED_DEVICES_REQUEST,
});

export const fetchTrustedDevicesSuccess = (devices) => ({
  type: actionTypes.FETCH_TRUSTED_DEVICES_SUCCESS,
  devices,
});

export const fetchTrustedDevicesFailure = () => ({
  type: actionTypes.FETCH_TRUSTED_DEVICES_FAILURE,
});

export const fetchTrustedDevices = () => async (dispatch) => {
  try {
    dispatch(fetchTrustedDevicesRequest());
    const devices = await api.fetchTrustedDevices();
    dispatch(fetchTrustedDevicesSuccess(devices));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('FETCH_TRUSTED_DEVICES', error);
    dispatch(fetchTrustedDevicesFailure());
  }
};

export const deleteTrustedDeviceRequest = () => ({
  type: actionTypes.DELETE_TRUSTED_DEVICE_REQUEST,
});

export const deleteTrustedDeviceSuccess = (uuid) => ({
  type: actionTypes.DELETE_TRUSTED_DEVICE_SUCCESS,
  uuid,
});

export const deleteTrustedDeviceFailure = () => ({
  type: actionTypes.DELETE_TRUSTED_DEVICE_FAILURE,
});

export const deleteTrustedDevice = (uuid) => async (dispatch) => {
  try {
    dispatch(deleteTrustedDeviceRequest());
    await api.deleteTrustedDevice(uuid);
    dispatch(deleteTrustedDeviceSuccess(uuid));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('DELETE_TRUSTED_DEVICE', error);
    dispatch(deleteTrustedDeviceFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/user/actions/trusted-devices.actions.js